import React from 'react';
import { useParams } from 'react-router-dom';
import AnimationRevealPage from "helpers/AnimationRevealPage.js"
import PaymentPage from 'pages/PaymentPage';
import VisitorPage from "pages/VisitorPage.js";
import Announcements from 'pages/Announcements.js';
import AccountingPage from 'pages/AccountingPage.js';
import AmenitiesPage from 'pages/AmenitiesPage';
import DocumentsPage from 'pages/DocumentsPage';
import VisitorRegisterPage from "pages/VisitorRegisterPage.js";
import RegistroVisitasPageImageSrc from "images/demo/qr-scan.png";
import VisitorHistoryPageImageSrc from "images/demo/visitor-history.png";
import PagosPageImageSrc from "images/demo/pagos.png";
import NotificationImageSrc from "images/demo/notification.png"
import AccountingImageSrc from "images/demo/accounting.png"
import AmenitiesPageImageSrc from "images/demo/amenities.png"
import DocumentsLandingPageImageSrc from "images/demo/documentation.png";
import AdminDashboardImageSrc from "images/demo/mainPage.png";
import AdminPaymentsImageSrc from "images/demo/pagos.png";
import AdminOwnersImageSrc from "images/demo/visitor-history.png";
import AdminAmenitiesImageSrc from "images/demo/amenities.png";
import AdminAccountingImageSrc from "images/demo/accounting.png";
import AdminAnnouncementsImageSrc from "images/demo/notification.png";
import { ROUTE_PATHS } from 'utils/routes';

export const components = {
  landingPages: {
    VisitorRegisterPage: {
      component: VisitorRegisterPage,
      imageSrc: RegistroVisitasPageImageSrc,
      url: ROUTE_PATHS.VISITREGISTER,
      name: "Registro de Visitantes",
    },
    VisitorPage: {
      component: VisitorPage,
      imageSrc: VisitorHistoryPageImageSrc,
      url: ROUTE_PATHS.VISIT,
      name: "Mis Visitas",
    },
    PaymentsLandingPage: {
      component: PaymentPage,
      imageSrc: PagosPageImageSrc,
      url: ROUTE_PATHS.PAYMENTS,
      name: "Mis pagos",
    },
    AnnouncementsLandingPage: {
      component: Announcements,
      imageSrc: NotificationImageSrc,
      url: ROUTE_PATHS.ANNOUNCEMENTS,
      name: "Anuncios",
    },
    AccountingLandingPage: {
      component: AccountingPage,
      imageSrc: AccountingImageSrc,
      url: ROUTE_PATHS.ACCOUNTING,
      name: "Contabilidad",
    },
    AmenitiesLandingPage: {
      component: AmenitiesPage,
      imageSrc: AmenitiesPageImageSrc,
      url: ROUTE_PATHS.AMENITIES,
      name: "Amenidades",
    },
    DocumentsLandingPage: {
      component: DocumentsPage,
      imageSrc: DocumentsLandingPageImageSrc,
      url: ROUTE_PATHS.DOCUMENTS,
      name: "Documentos",
    }
  },
  adminPages: {
    AdminDashboardPage: {
      component: () => import('pages/AdminDashboardPage'),
      imageSrc: AdminDashboardImageSrc,
      url: ROUTE_PATHS.ADMINDASHBOARD,
      name: "Panel Principal",
      description: "Centro de control administrativo"
    },
    AdminPaymentsPage: {
      component: () => import('pages/AdminPaymentsPage'),
      imageSrc: AdminPaymentsImageSrc,
      url: ROUTE_PATHS.ADMINPAYMENTPAGE,
      name: "Gestión de Pagos",
      description: "Administrar todos los pagos del fraccionamiento"
    },
    AdminOwnersPage: {
      component: () => import('pages/AdminOwnersPage'),
      imageSrc: AdminOwnersImageSrc,
      url: ROUTE_PATHS.ADMINOWNERSPAGE,
      name: "Gestión de Propietarios",
      description: "Administrar propietarios y fraccionamientos"
    },
    AdminAmenitiesPage: {
      component: () => import('pages/AdminAmenitiesPage'),
      imageSrc: AdminAmenitiesImageSrc,
      url: ROUTE_PATHS.ADMINAMENITIESPAGE,
      name: "Gestión de Amenidades",
      description: "Administrar amenidades y reservaciones"
    },
    AdminAccountingPage: {
      component: () => import('pages/AdminAccountingPage'),
      imageSrc: AdminAccountingImageSrc,
      url: ROUTE_PATHS.ADMINACCOUNTINGPAGE,
      name: "Contabilidad Administrativa",
      description: "Gestión financiera y reportes contables"
    },
    AdminAnnouncementsPage: {
      component: () => import('pages/AdminAnnouncementsPage'),
      imageSrc: AdminAnnouncementsImageSrc,
      url: ROUTE_PATHS.ADMINANNOUNCEMENTSPAGE,
      name: "Gestión de Anuncios",
      description: "Crear y administrar anuncios para residentes"
    }
  },
}

export default () => {
  const { type, subtype, name } = useParams()

  try {
    let Component = null;
    if(type === "blocks" && subtype) {
      Component= components[type][subtype]["elements"][name].component
      return <AnimationRevealPage disabled>
          <Component/>
        </AnimationRevealPage>
    }
    else
      Component= components[type][name].component

    if(Component)
      return <Component/>

    throw new Error("Component Not Found")
  }
  catch (e) {
    console.log(e)
    return <div>Error: Component Not Found</div>
  }
}
